import { Translate } from '@chipinside/translate'

import { EntityConfigEntry, EntityKey } from '#/components/AdvancedSearch/types'
import { getLink } from '#/utils/getLink'

export const ENTITY_CONFIG: Record<EntityKey, EntityConfigEntry> = {
  animals: {
    description: item =>
      item?.collar?.code
        ? Translate({ messageKey: 'collar' }) + `: ${item?.collar?.code}`
        : Translate({ messageKey: 'no_collar' }),
    link: item =>
      getLink({
        fallback: 'farm-animal-reproduction',
        id: 'farm-animal-daily-monitoring',
        // Trata todo animal na busca como fêmea, para que o link seja gerado mesmo que o animal do withAnimal seja macho.
        // Corrigindo o erro de acessar uma fazendo `cow-connect` e acessar um animal macho e na busca global clicar em um animal.
        // Caso o animal seja macho, e for redirecionado para /reproduction o usuário verá a primeira tab habilitada graças ao componente de Tabs que verifica se a tab acessada é conhecida e não está habilitada e dai redireciona para a primeira tab habilitada.
        // No futuro tentar pedir para o backend enviar essa informação de is_female para o animal na busca global.
        params: { animal: item.slug, is_female: true },
      }) as string,
    locate: item => (item.collar ? { identifier: item.slug, type: 'animal' } : undefined),
    text: item => [item.earring, item.name]?.filter(Boolean).join(' - '),
    titleKey: 'animal_plural',
  },
  batches: {
    description: item => item?.type?.text,
    link: item => getLink({ id: 'farm-batch-monitoring', params: { batch: item.slug } }) as string,
    text: item => item.name,
    titleKey: 'batch_plural',
  },
  collars: {
    link: item =>
      getLink({
        id: 'farm-monitoring-c-tech-collar-report-map',
        params: { ctech: item.code },
      }) as string,
    locate: item => ({ identifier: item.code, type: 'collar' }),
    text: item => item.code,
    titleKey: 'collar_plural',
  },
  farms: {
    link: item => getLink({ id: 'farm-dashboard', params: { farm: item.value } }) as string,
    text: item => item.label,
    titleKey: 'farm_plural',
  },
}

/** Ordem de exibição das entidades: fora da fazenda, as fazendas vêm primeiro */
export const getEntityKeys = (isFarmContext: boolean): EntityKey[] => {
  const keys = Object.keys(ENTITY_CONFIG) as EntityKey[]

  return isFarmContext ? keys : ['farms']
}
